export enum ApplicationCallPurpose {
	SCHEDULE_A_CALL = 'SCHEDULE_A_CALL',
	READY_FOR_LOAN_INTERVIEW = 'READY_FOR_LOAN_INTERVIEW',
	ADMINISTRATIVE = 'ADMINISTRATIVE',
}

export namespace ApplicationCallPurpose {
	export function toDisplayText(
		applicationCallPurpose: ApplicationCallPurpose
	): string {
		switch (applicationCallPurpose) {
			case ApplicationCallPurpose.SCHEDULE_A_CALL:
				return 'Schedule a call';
			case ApplicationCallPurpose.READY_FOR_LOAN_INTERVIEW:
				return 'Ready for loan interview';
			case ApplicationCallPurpose.ADMINISTRATIVE:
				return 'Administrative';
			default:
				return applicationCallPurpose;
		}
	}
}
